/**
 * Базовый словарь тегов ассортимента (F2, ADR 0014): «обычно есть здесь»,
 * НЕ инвентарь и НЕ SKU. Данные — tags.json (54 тега: slug kebab-case,
 * names{et,en,ru}, синонимы всех языков в нижнем регистре); арендаторские
 * свободные теги — статус pending в БД (таблица tags) до одобрения владельцем.
 */
import rawTags from './tags.json'

/** Тег ассортимента «обычно есть здесь» (ADR 0014; НЕ инвентарь). */
export interface AssortmentTag {
  readonly slug: string
  readonly names: { readonly et: string; readonly en: string; readonly ru: string }
  readonly synonyms: readonly string[]
}

export const BASE_TAGS: readonly AssortmentTag[] = rawTags as readonly AssortmentTag[]
